import { Component, Input } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrl: './error.component.scss',
    standalone: false
})
export class ErrorComponent {
  @Input() errorMessage: string = '';
  @Input() titleError: string = '';

  constructor(
    private auth: AuthService
  ) { }

  logout(): void {
    this.auth.logout();
  }

  get isNotAuthorized(): boolean {
    return this.titleError === '401';
  }
}
